import { useEffect } from "react";
import { useSearchParams } from 'react-router-dom'
import { loadLegacyWocr } from "./loadLegacyWocr";
import "./Quram.css";

export default function QuramOcrApp() {
	const [searchParams] = useSearchParams()
	useEffect(() => {
		const cameraMode = searchParams.get('cameraMode')
		const ocrInterTime = searchParams.get('ocrInterTime')
		const ocrThreshold = searchParams.get('ocrThreshold')
		const ocrCDN = searchParams.get('ocrCDN')

		console.log(cameraMode);
		console.log(ocrInterTime);
		console.log(ocrThreshold);
		console.log(ocrCDN);
		
		loadLegacyWocr().catch((err) => {
			console.error(err);
		});
	}, []);

	return <div id="wocr-host" className="wocr-host" />;
}
